/**
 * Krishna Yajurveda Utility Functions
 * Common functions for handling Krishna Yajurveda vatu data across pages
 */

// Tree structure for Krishna Yajurveda grandhams
export const krishnaYajurvedaTreeData = {
  telugu: {
    'బ్రాహ్మణము': {
      'ప్రథమాష్టకము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయాష్టకము': [1, 2, 3, 4, 5, 6, 7, 8],
      'తృతీయాష్ఠకము': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },
    'ఆరణ్యకభాగము': {
      'main': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      'ఏకాగ్ని కాండము': [1, 2],
    },
    'సంహితా': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'పదము': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'క్రమము': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    }
  },
  sanskrit: {
    'ब्राह्मणम्': {
      'प्रथमाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'तृतीयाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },
    'आरण्यकभागः': {
      'main': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      'एकाग्नि काण्डम्': [1, 2],
    },
    'संहिता': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'पदम्': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'क्रमम्': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    }
  }
};

/**
 * Count total pannams expected in a grandham
 * @param {string} grandhamKey - The grandham name (Telugu or Sanskrit)
 * @param {string} lang - Language: 'telugu' or 'sanskrit'
 * @returns {number} Total expected pannams
 */
export const getTotalExpectedPannams = (grandhamKey, lang = 'telugu') => {
  const treeForLang = krishnaYajurvedaTreeData[lang] || krishnaYajurvedaTreeData.telugu;
  const expectedStructure = treeForLang[grandhamKey];

  if (!expectedStructure) return 0;

  let total = 0;
  for (const sectionName of Object.keys(expectedStructure)) {
    const pannumList = expectedStructure[sectionName] || [];
    total += pannumList.length;
  }
  return total;
};

/**
 * Count pannams in a specific grandham
 * @param {object} krishnaYajurvedaObj - Krishna Yajurveda object
 * @param {string} grandhamKey - The grandham name (Telugu or Sanskrit)
 * @param {string} lang - Language: 'telugu' or 'sanskrit'
 * @returns {number} Total pannams in the grandham
 */
export const countPannamsInGrandham = (krishnaYajurvedaObj, grandhamKey, lang = 'telugu') => {
  if (!krishnaYajurvedaObj || typeof krishnaYajurvedaObj !== 'object') return 0;

  const treeForLang = krishnaYajurvedaTreeData[lang] || krishnaYajurvedaTreeData.telugu;
  const expectedStructure = treeForLang[grandhamKey];

  if (!expectedStructure) return 0;

  // Extract the grandham object from the krishna_yajurveda object
  const grandhamObj = krishnaYajurvedaObj[grandhamKey];
  if (!grandhamObj || typeof grandhamObj !== 'object') return 0;

  let totalPannams = 0;
  
  // Special rule for aranyakam: if ఏకాగ్ని కాండము (or एकाग्नि काण्डम्) is NOT selected alone,
  // count 12 pannams instead of 10
  const isAranyakamTelugu = grandhamKey === 'ఆరణ్యకభాగము';
  const isAranyakamSanskrit = grandhamKey === 'आरण्यकभागः';
  const isAranyakam = isAranyakamTelugu || isAranyakamSanskrit;
  const ekaagniKandaNameTelugu = 'ఏకాగ్ని కాండము';
  const ekaagniKandaNameSanskrit = 'एकाग्नि काण्डम्';
  const ekaagniKandaName = lang === 'telugu' ? ekaagniKandaNameTelugu : ekaagniKandaNameSanskrit;

  // Iterate through sections in expected structure
  for (const sectionName of Object.keys(expectedStructure)) {
    const pannumList = expectedStructure[sectionName] || [];

    // Check if section is marked as selected
    if (grandhamObj[sectionName] && grandhamObj[sectionName]._selected === true) {
      totalPannams += pannumList.length;
      continue;
    }

    // Count individual pannams in section
    if (grandhamObj[sectionName] && typeof grandhamObj[sectionName] === 'object') {
      for (const pannum of pannumList) {
        if (grandhamObj[sectionName][pannum] !== undefined && grandhamObj[sectionName][pannum] !== null) {
          totalPannams++;
        }
      }
    } else {
      // Only count pannams directly under grandham for 'main' section
      if (sectionName !== 'main') continue;
      // Some payloads place pannams directly under grandham
      for (const pannum of pannumList) {
        if (grandhamObj[pannum] !== undefined && grandhamObj[pannum] !== null) {
          totalPannams++;
        }
      }
    }
  }

  // Special rule for aranyakam: if only main section is selected (10 pannams)
  // and ఏకాగ్ని కాండము is NOT selected alone, count 12 instead of 10
  if (isAranyakam && totalPannams === 10) {
    // Check if main section has pannams but ఏకాగ్ని కాండము section is not selected
    const mainSelected = totalPannams > 0;
    const ekaagniSelected = grandhamObj[ekaagniKandaName] && 
      (grandhamObj[ekaagniKandaName]._selected === true || 
       Object.values(grandhamObj[ekaagniKandaName]).some(v => v !== null && v !== undefined && v !== '_selected'));
    
    if (mainSelected && !ekaagniSelected) {
      totalPannams = 12;
    }
  }

  return totalPannams;
};

/**
 * Get Krishna Yajurveda grandham info with pannam counts
 * Applies rules for counting pannams from previous and current grandhams
 * @param {object} vatu - Vatu object with grandham_data
 * @param {string} lang - Language: 'telugu' or 'sanskrit'
 * @returns {array} Array of grandham info objects with { grandhamName, pannams, isComplete? }
 */
export const getKrishnaGrandhamInfo = (vatu, lang = 'telugu') => {
  const grandhamInfos = [];

  const currentGrandha = getGrandhamTypePhase(vatu, 'krishna_yajurveda', 'current');
  const previousGrandha = getGrandhamTypePhase(vatu, 'krishna_yajurveda', 'previous');

  const keys = lang === 'telugu'
    ? { brahmana: 'బ్రాహ్మణము', aranyaka: 'ఆరణ్యకభాగము', samhita: 'సంహితా', padamu: 'పదము', kramamu: 'క్రమము', jata: 'జటా', ghanam: 'ఘనము' }
    : { brahmana: 'ब्राह्मणम्', aranyaka: 'आरण्यकभागः', samhita: 'संहिता', padamu: 'पदम्', kramamu: 'क्रमम्', jata: 'जटा', ghanam: 'घनम्' };

  // Helper to apply counting rules for a grandham
  const applyCountingRules = (grandhamKey) => {
    const totalExpected = getTotalExpectedPannams(grandhamKey, lang);
    
    const previousPannams = countPannamsInGrandham(previousGrandha, grandhamKey, lang);
    const currentPannams = countPannamsInGrandham(currentGrandha, grandhamKey, lang);
    
    const previousComplete = previousPannams > 0 && previousPannams === totalExpected;
    const previousPartial = previousPannams > 0 && !previousComplete;
    const currentHasPannams = currentPannams > 0;

    let totalPannams = 0;
    let completions = "";

    // Rule 2: If previous has all pannams, don't count (skip)
    if (previousComplete) {
      totalPannams = previousPannams;
      completions = "previous-complete";
    }
    // Rule 1: If previous has partial AND current has pannams, count both
    else if (previousPartial && currentHasPannams) {
      totalPannams = previousPannams + currentPannams;
      completions = "current-previous-partial";
    }
    // Rule 3: If previous has partial (no current), count previous only
    else if (previousPartial) {
      totalPannams = previousPannams;
      completions = "previous-partial";
    }
    // Rule 4: If no previous but current has pannams, count current
    else if (currentHasPannams) {
      totalPannams = currentPannams;
      completions = "current-only";
    }
    
    if (totalPannams === 0) return null;

    return {
      grandhamName: grandhamKey,
      pannams: totalPannams,
      completionType: completions,
      isComplete: totalPannams === totalExpected
    };
  };

  // Handle parayatham (brahmanam + aranyakam) using combined rules
  const parayathamKey = lang === 'telugu' ? 'పరాయతం' : 'परायतम्';
  const previousBrahmanaPannams = countPannamsInGrandham(previousGrandha, keys.brahmana, lang);
  const previousAranyakaPannams = countPannamsInGrandham(previousGrandha, keys.aranyaka, lang);
  const currentBrahmanaPannams = countPannamsInGrandham(currentGrandha, keys.brahmana, lang);
  const currentAranyakaPannams = countPannamsInGrandham(currentGrandha, keys.aranyaka, lang);

  const totalExpectedBrahmana = getTotalExpectedPannams(keys.brahmana, lang);
  const totalExpectedAranyaka = getTotalExpectedPannams(keys.aranyaka, lang);

  const previousBrahmanComplete = previousBrahmanaPannams > 0 && previousBrahmanaPannams === totalExpectedBrahmana;
  const previousAranyakaComplete = previousAranyakaPannams > 0 && previousAranyakaPannams === totalExpectedAranyaka;
  const previousBrahmanPartial = previousBrahmanaPannams > 0 && !previousBrahmanComplete;
  const previousAranyakaPartial = previousAranyakaPannams > 0 && !previousAranyakaComplete;

  const currentBrahmanHasPannams = currentBrahmanaPannams > 0;
  const currentAranyakaHasPannams = currentAranyakaPannams > 0;
  const currentHasParayathamPannams = currentBrahmanHasPannams || currentAranyakaHasPannams;
  const previousBrahmanHasPannams = previousBrahmanaPannams > 0;
  const previousAranyakaHasPannams = previousAranyakaPannams > 0;
  const previousHasParayathamPannams = previousBrahmanHasPannams || previousAranyakaHasPannams;

  let totalParayathamPannams = 0;
  let totalCompletions = "";

  // Rule 2: If previous has all pannams, don't count (skip)
  if (previousBrahmanComplete && previousAranyakaComplete) {
    totalParayathamPannams = previousBrahmanaPannams + previousAranyakaPannams;
    totalCompletions = "previous-complete";
  }
  // Rule 1: If previous has partial AND current has parayatham pannams, count both
  else if (previousHasParayathamPannams && currentHasParayathamPannams) {
    totalParayathamPannams = previousBrahmanaPannams + previousAranyakaPannams + currentBrahmanaPannams + currentAranyakaPannams;
    totalCompletions = "current-previous-partial";
  }
  // Rule 3: If previous has partial (no current), count previous only
  else if (previousHasParayathamPannams) {
    totalParayathamPannams = previousBrahmanaPannams + previousAranyakaPannams;
    totalCompletions = "previous-partial";
  }
  // Rule 4: If no previous but current has parayatham pannams, count current
  else if (currentHasParayathamPannams) {
    totalParayathamPannams = currentBrahmanaPannams + currentAranyakaPannams;
    totalCompletions = "current-only";
  }

  if (totalParayathamPannams > 0) {
    grandhamInfos.push({
      grandhamName: parayathamKey,
      pannams: totalParayathamPannams,
      completionType: totalCompletions,
      isComplete: totalParayathamPannams === (totalExpectedBrahmana + totalExpectedAranyaka)
    });
  }

  // Handle other grandhams
  const otherGrandhams = ['samhita', 'padamu', 'kramamu', 'jata', 'ghanam'];
  for (const grandhamType of otherGrandhams) {
    const key = keys[grandhamType];
    const result = applyCountingRules(key);
    if (result) {
      grandhamInfos.push(result);
    }
  }
  console.log('Grandham Infos:', vatu.vatu_id, grandhamInfos);
  return grandhamInfos;
};

// Krishna Yajurveda filter categories - Refactored with proper pannam counting
export const categorizeKrishnaVatu = (vatu, lang) => {
    const currentGrandha = getGrandhamTypePhase(vatu, 'krishna_yajurveda', 'current');
    const previousGrandha = getGrandhamTypePhase(vatu, 'krishna_yajurveda', 'previous');
    
    const type = vatu.krishnaYajurvedaType;
    const patta_type = vatu.krishnaYajurvedaKramantham;

    const telugu = {
      brahmana: 'బ్రాహ్మణము',
      aranyaka: 'ఆరణ్యకభాగము',
      samhita: 'సంహితా',
      padamu: 'పదము',
      kramamu: 'క్రమము',
      jata: 'జటా',
      ghanam: 'ఘనము'
    };

    const sanskrit = {
      brahmana: 'ब्राह्मणम्',
      aranyaka: 'आरण्यकभागः',
      samhita: 'संहिता',
      padamu: 'पदम्',
      kramamu: 'क्रमम्',
      jata: 'जटा',
      ghanam: 'घनम्'
    };

    const keys = lang === 'telugu' ? telugu : sanskrit;

    // Helper function to get pannam count for a grandham following the rules
    const getGrandhamPannamCount = (grandhamKey) => {
      const totalExpected = getTotalExpectedPannams(grandhamKey);
      
      const previousPannams = countPannamsInGrandham(previousGrandha, grandhamKey);
      const currentPannams = countPannamsInGrandham(currentGrandha, grandhamKey);
      
      const previousComplete = previousPannams > 0 && previousPannams === totalExpected;
      const previousPartial = previousPannams > 0 && !previousComplete;
      const currentHasPannams = currentPannams > 0;

      let totalPannams = 0;
      let totalCompletions = "";

      // Rule 2: If previous has all pannams, count only for parayatham else don't count (skip)
      if (previousComplete) {
        // Parayatham special case: always count previous if complete
        // totalPannams = (grandhamKey === keys.brahmana || grandhamKey === keys.aranyaka) ? previousPannams : 0;
        totalPannams = previousPannams;
        totalCompletions = "previous-complete";
      }
      // Rule 1: If previous has partial AND current has pannams, count both
      else if (previousPartial && currentHasPannams) {
        totalPannams = previousPannams + currentPannams;
        totalCompletions = "current-previous-partial";
      }
      // Rule 3: If previous has partial (no current), count previous only
      else if (previousPartial) {
        totalPannams = previousPannams;
        totalCompletions = "previous-partial";
      }
      // Rule 4: If no previous but current has pannams, count current
      else if (currentHasPannams) {
        totalPannams = currentPannams;
        totalCompletions = "current-only";
      }

      return {totalPannams: totalPannams, completionType: totalCompletions};
    };

    // Get pannam counts for each grandham with rules applied
    const brahmanaCount = getGrandhamPannamCount(keys.brahmana);
    const aranyakaCount = getGrandhamPannamCount(keys.aranyaka);
    const samhitaCount = getGrandhamPannamCount(keys.samhita);
    const padamuCount = getGrandhamPannamCount(keys.padamu);
    const kramamuCount = getGrandhamPannamCount(keys.kramamu);
    const jataCount = getGrandhamPannamCount(keys.jata);
    const ghanamCount = getGrandhamPannamCount(keys.ghanam);

    // Get total expected for each grandham
    const totalExpectedBrahmana = getTotalExpectedPannams(keys.brahmana);
    const totalExpectedAranyaka = getTotalExpectedPannams(keys.aranyaka);
    const totalExpectedSamhita = getTotalExpectedPannams(keys.samhita);
    const totalExpectedPadamu = getTotalExpectedPannams(keys.padamu);
    const totalExpectedKramamu = getTotalExpectedPannams(keys.kramamu);
    const totalExpectedJata = getTotalExpectedPannams(keys.jata);
    const totalExpectedGhanam = getTotalExpectedPannams(keys.ghanam);

    // Check if each grandham is complete (actual pannams = expected pannams)
    const brahmanaComplete = brahmanaCount.totalPannams > 0 && brahmanaCount.totalPannams === totalExpectedBrahmana;
    const aranyakaComplete = aranyakaCount.totalPannams > 0 && aranyakaCount.totalPannams === totalExpectedAranyaka;
    const samhitaComplete = samhitaCount.totalPannams > 0 && samhitaCount.totalPannams === totalExpectedSamhita;
    const padamuComplete = padamuCount.totalPannams > 0 && padamuCount.totalPannams === totalExpectedPadamu;
    const kramamuComplete = kramamuCount.totalPannams > 0 && kramamuCount.totalPannams === totalExpectedKramamu;
    const jataComplete = jataCount.totalPannams > 0 && jataCount.totalPannams === totalExpectedJata;
    const ghanamComplete = ghanamCount.totalPannams > 0 && ghanamCount.totalPannams === totalExpectedGhanam;

    // Combined categories
    const moolamComplete = brahmanaComplete && aranyakaComplete && samhitaComplete;
    const padamuMoolamComplete = moolamComplete && padamuComplete;
    const kramamuPadamuComplete = padamuMoolamComplete && kramamuComplete;
    const jataCategoryComplete = kramamuPadamuComplete && jataComplete;
    const ghanaCategoryComplete = jataCategoryComplete && ghanamComplete;

    // Categorize based on selections and type
    if (type === 'pattaa_pariksha') {
      // Pattaa pariksha cases
      if (patta_type === "vishesha_kramamu") {
        if (kramamuPadamuComplete && jataCount.totalPannams === 0 && ghanamCount.totalPannams === 0) return 'vishesha_kramamu';
      }
      if (patta_type === 'vishesha_ghanamu') {
        if (ghanaCategoryComplete) return 'vishesha_ghanamu';
      }
    }

    // Varshika pariksha cases (ordered by progression)
    if (ghanaCategoryComplete) return 'saamaanya_ghanamu';
    if (jataCategoryComplete && ghanamCount.totalPannams === 0) return 'jata';
    if (kramamuPadamuComplete && jataCount.totalPannams === 0 && ghanamCount.totalPannams === 0 && 
        patta_type !== 'vishesha_kramamu') {
      return 'saamaanya_kramamu';
    }
    if (kramamuComplete && !kramamuPadamuComplete) return 'kramamu';
    if (padamuComplete && kramamuCount.totalPannams === 0) return 'padamu';
    if (moolamComplete && padamuCount.totalPannams === 0 && kramamuCount.totalPannams === 0) return 'moolam';

    if (samhitaComplete && samhitaCount.completionType != "previous-complete" && !brahmanaComplete && !aranyakaComplete) return 'samhita';
    if (brahmanaComplete && brahmanaCount.completionType != "previous-complete" && !aranyakaComplete && !samhitaComplete) return 'brahmana';
    if (aranyakaComplete && aranyakaCount.completionType != "previous-complete" && !brahmanaComplete && !samhitaComplete) return 'aranyaka';
    
    // Khanda - partial selections (not full moolam)
    return 'khanda';
  };


  // ============ VATU ASSIGNMENT FUNCTIONS ============
// Step 2: Categorize vatus based on pannam info
export const categorizeVatu = (vatuData, lang, isParikshaTypeFilter = false) => {
    // Call getKrishnaGrandhamInfo first to get pannam info
    if (!vatuData) return 'Mulam - Junior';
    
    const grandhamInfos = getKrishnaGrandhamInfo(vatuData, lang);
    
    // Extract counts from grandham info
    const getGrandhamCount = (grandhamType) => {
      const info = grandhamInfos.find(g => 
        g.grandhamName.includes(lang === 'telugu' ? 
          (grandhamType === 'parayatham' ? 'పరాయతం' : 
           grandhamType === 'samhita' ? 'సంహితా' :
           grandhamType === 'padamu' ? 'పదము' :
           grandhamType === 'kramamu' ? 'క్రమము' :
           grandhamType === 'jata' ? 'జటా' :
           grandhamType === 'ghanam' ? 'ఘనము' : '')
          :
          (grandhamType === 'parayatham' ? 'परायतम्' :
           grandhamType === 'samhita' ? 'संहिता' :
           grandhamType === 'padamu' ? 'पदम्' :
           grandhamType === 'kramamu' ? 'क्रमम्' :
           grandhamType === 'jata' ? 'जटा' :
           grandhamType === 'ghanam' ? 'घनम्' : '')
        )
      );
      return info?.completionType === "previous-complete" ? 0 : info?.pannams || 0;
    };

    const parayathamSamhitaCount = getGrandhamCount('parayatham') + getGrandhamCount('samhita');
    const padamuCount = getGrandhamCount('padamu');
    const kramamuCount = getGrandhamCount('kramamu');
    const isJata = grandhamInfos.find(
      g =>
        g.grandhamName.includes(lang === "telugu" ? "జటా" : "जटा") &&
        !g.grandhamName.includes(lang === "telugu" ? "ఘనము" : "घनम्")
    );
    
    const fullKramamu = lang === "telugu" ? ["పరాయతం", "సంహితా", "పదము", "క్రమము"].every(
      (name) => grandhamInfos.find(g => g.grandhamName === name && g.isComplete && g.completionType === "current-only")
    ) && !["జటా", "ఘనము"].every((name) => grandhamInfos.find(g => g.grandhamName === name && !g.isComplete )) : ["परायतम्", "संहिता", "पदम्", "क्रमम्"].every(
      (name) => grandhamInfos.find(g => g.grandhamName === name && g.isComplete && g.completionType === "current-only")
    ) && !["जटा", "घनम्"].every((name) => grandhamInfos.find(g => g.grandhamName === name && !g.isComplete));
   
    const fullGhanam = lang === "telugu" ? ["పరాయతం", "సంహితా", "పదము", "క్రమము", "జటా", "ఘనము"].every(
      (name) => grandhamInfos.find(g => g.grandhamName === name && g.isComplete && g.completionType === "current-only")
    ) : ["परायतम्", "संहिता", "पदम्", "क्रमम्", "जटा", "घनम्"].every(
      (name) => grandhamInfos.find(g => g.grandhamName === name && g.isComplete && g.completionType === "current-only")
    );
    
    grandhamInfos.some(g => g.grandhamName.includes(lang === "telugu" ? "ఘనము" : "घनम्"));
    
    // Check for krishnaYajurvedaKramantham in vatu data
    const hasKrishnaYajurvedaKramantham = vatuData?.krishnaYajurvedaKramantham || false;

    // SPECIAL CATEGORY
    if (fullKramamu || fullGhanam) {
      console.log('Special Category Matched:', vatuData.vatu_id, fullKramamu, fullGhanam, hasKrishnaYajurvedaKramantham);
      return 'Special';
    }

    // Collect all matching categories with their pannam counts
    const matchingCategories = [];
    
    // Check Mulam (Parayatham + Samhita)
    if (parayathamSamhitaCount <= 22) {
      matchingCategories.push({ category: 'Mulam - Junior', pannams: parayathamSamhitaCount });
    } else if (parayathamSamhitaCount > 22 && parayathamSamhitaCount <= 44) {
      matchingCategories.push({ category: 'Mulam - Senior', pannams: parayathamSamhitaCount });
    } else if (parayathamSamhitaCount > 44) {
      matchingCategories.push({ category: 'Mulam - Expert', pannams: parayathamSamhitaCount });
    }
    
    // Check Padamu
    if (padamuCount <= 22) {
      matchingCategories.push({ category: 'Padamu - Junior', pannams: padamuCount });
    } else if (padamuCount > 22 && padamuCount <= 44) {
      matchingCategories.push({ category: 'Padamu - Senior', pannams: padamuCount });
    } else if (padamuCount > 44) {
      matchingCategories.push({ category: 'Padamu - Expert', pannams: padamuCount });
    }
    
    // Check Kramamu
    if (kramamuCount <= 22) {
      matchingCategories.push({ category: 'Kramamu - Junior', pannams: kramamuCount });
    } else if (kramamuCount > 22 && kramamuCount <= 44) {
      matchingCategories.push({ category: 'Kramamu - Senior', pannams: kramamuCount });
    } else if (kramamuCount > 44) {
      matchingCategories.push({ category: 'Kramamu - Expert', pannams: kramamuCount });
    }
    
    // If we have matching categories, return the one with most pannams
    if (matchingCategories.length > 0) {
      // Sort by pannams descending and return the first one (highest pannams)
      return matchingCategories.sort((a, b) => b.pannams - a.pannams)[0].category;
    }

    if (isJata) return 'Jata';
    
    return 'Mulam - Junior'; // Default
  };
import { getGrandhamTypePhase } from './grandhamDataUtils';
